import { z } from "zod";
import { ForgeParticipant } from "./participant";

export const ForgeIterationMessageStep = z.object({
  name: z.string(),
  text: z.string(),
  status: z.enum(["pending", "started", "completed", "error"]),
});

export const ForgeIterationMessage = z.object({
  id: z.string(),
  createdAt: z.coerce.date(),
  participantId: z.string(),
  participant: ForgeParticipant,
  projectIterationId: z.string(),
  steps: z.array(ForgeIterationMessageStep).optional(),
  type: z.enum(["Note", "Action", "Steps"]),
  text: z.string(),
});

export type ForgeIterationMessage = z.infer<typeof ForgeIterationMessage>;
